export const getInitial = (string: string): string =>
  string.charAt(0).toLocaleUpperCase();
